import { onBeforeUnmount, onMounted, Ref, ref } from 'vue';

export function useStickyOnIntersect(targetRef: Ref<HTMLElement | null>) {
  const showSticky = ref(false);
  let observer: IntersectionObserver | null = null;

  onMounted(() => {
    if (!targetRef.value) return;

    observer = new IntersectionObserver(
      ([entry]) => {
        // Show sticky when target is out of view
        showSticky.value = !entry.isIntersecting;
      },
      {
        root: null,
        threshold: 0,
      },
    );

    observer.observe(targetRef.value);
  });

  onBeforeUnmount(() => {
    if (observer && targetRef.value) {
      observer.disconnect();
    }
  });

  return {
    showSticky,
  };
}
